export default "__VITE_ASSET__B9pMAiX8__"